import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';
import { Teacher } from 'src/app/models/teacher.model';
import { Router } from '@angular/router';
import { getLocalTranslate } from 'src/app/helpers/global-functions'
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-instructors',
  templateUrl: './instructors.component.html',
  styleUrls: ['./instructors.component.css']
})
export class InstructorsComponent  implements OnInit {

  showSpinner:boolean = false

  teachers:Teacher[] = []

  instructors:string = 'Instructors'
  home:string = 'Home'

  constructor(
    private homeService:HomeService,
    private router:Router,
    private titleService: Title
  ) {  }

  ngOnInit(): void {
    this.getTeachers()
    this.needTranslate()
    this.titleService.setTitle(`${getLocalTranslate('instructors',this.instructors)} | CamEdu`)
  }

  needTranslate(){
    this.instructors = getLocalTranslate('instructors',this.instructors)
    this.home = getLocalTranslate('home',this.home)
  }

  getTeachers(){
    this.showSpinner = true
    this.homeService.getTeachers(15).then(teachers=>{
      this.teachers = teachers
      this.showSpinner = false
    })
  }

  routeToTeacherDetail(id:string){
    this.router.navigate(['/instructor/' + id]);
  }
}

